<script setup>
import {useI18n} from 'vue-i18n';
import {onMounted, ref} from 'vue';
import {getTenantData} from "@/services/TenantService";

const {t} = useI18n()
const tenantInfo = ref({});
const tenantTheme = ref({});

onMounted(() => {
  tenantInfo.value = localStorage.getItem('TENANT_INFO');
  tenantTheme.value = localStorage.getItem('TENANT_THEME');
})

getTenantData()
    .then((response) => {
      tenantTheme.value = response.theme;
      tenantInfo.value = response.tenant;
    });
</script>

<template>
  <footer class="onboarding-footer">
    <div class="p-2 h-100 d-flex align-items-center justify-content-center">
      <span class="onboarding-footer-text">Tel.: {{ tenantInfo.phone }}, E-mail: {{ tenantInfo.email }}</span>
    </div>
  </footer>
</template>
